import {useQuery} from '@aboutyou/data-fetcher';
import {USER_CACHE_KEY} from '../../CacheKeys';
import {createDataStore} from '../createDataStore';
import {USER_PERSIST_KEY} from './constants';
import {UserState} from './types';
import {delayCustomerDataToPreventHydrationErrors} from '../../utils/delayCustomerDataToPreventHydrationErrors';

export const initialUserState: UserState = {
  checkoutSession: null,
};

export const cleanupUserPersistedState = () => {
  localStorage.removeItem(USER_PERSIST_KEY);
};

const useExpensiveUser = () => {
  return useQuery(
    USER_CACHE_KEY,
    async (): Promise<UserState> => {
      await delayCustomerDataToPreventHydrationErrors();

      const persisted = globalThis.localStorage
        ? localStorage.getItem(USER_PERSIST_KEY)
        : null;

      const userDataFromLocalStorage = persisted ? JSON.parse(persisted) : null;

      const userState: UserState = {
        ...initialUserState,
        ...userDataFromLocalStorage,
      };
      return userState;
    },
    {
      onSuccess: onUserSuccess,
    },
  );
};

export const USER_DATA_EXCLUDED_FROM_PERSISTING = ['guestToken'];

const onUserSuccess = (userState: UserState) => {
  const userStateWithoutGuestTokenAndOptional = Object.fromEntries(
    Object.entries(userState).filter(
      ([key]) => !USER_DATA_EXCLUDED_FROM_PERSISTING.includes(key),
    ),
  );

  if (
    ('token' in userState && userState.token) ||
    ('guestToken' in userState && userState.guestToken)
  ) {
    localStorage.setItem(
      USER_PERSIST_KEY,
      JSON.stringify(userStateWithoutGuestTokenAndOptional),
    );
  }
};

const {Provider, useData: useUser} = createDataStore<UserState>({
  defaultValue: {
    checkoutSession: null,
  },
  useQueryHook: useExpensiveUser,
});

export {Provider as UserProvider, useUser};
